import { render, staticRenderFns } from "./ingredients.vue?vue&type=template&id=275523f3&scoped=true&"
import script from "./ingredients.vue?vue&type=script&lang=js&"
export * from "./ingredients.vue?vue&type=script&lang=js&"
import style0 from "./ingredients.vue?vue&type=style&index=0&id=275523f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275523f3",
  null
  
)

export default component.exports